import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance";
import { ToastContainer, toast } from "react-toastify";


export const fetchCommunityData = createAsyncThunk(
  "community/fetchCommunityData",
  async ({ page, page_size, search }, { rejectWithValue }) => {
    try {
    

      // Correct placement of headers and params
      const response = await axiosInstance.get("/auth/provider/", {
        // headers: getAuthHeaders(),
        params: { page, page_size, search },
      });

   
      return response.data;
    } catch (error) {
      console.error("Error fetching community data:", error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


export const fetchCommunityDocName = createAsyncThunk(
  "community/fetchCommunityDocName",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        "/community/community_doc_name_list/"
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);



//for getting single provider 

export const fetchCommunityByCommunityId = createAsyncThunk(
  "community/fetchCommunityDataById",
  async (id, { rejectWithValue }) => {
    try {
      // const token = localStorage.getItem("accessToken"); //  Token check
      // if (!token) {
      //   console.warn("Token missing! Redirecting to login...");
      //   window.location.href = "/"; //  User ko redirect karein
      //   return rejectWithValue("Token missing");
      // }

      // const response = await axiosInstance.get(`/auth/provider/${id}/`, {
      //   headers: {
      //     Authorization: `Bearer ${token}`  //  Ensure token is added
      //   },
      // });
      const response = await axiosInstance.get(`/provider/${id}/`,
        // { headers: getAuthHeaders() }  
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : "An error occurred"
      );
    }
  }
);



// export const fetchCommunityByCommunityId = createAsyncThunk(
//   "community/fetchCommunityDataById",
//   async (id, { rejectWithValue }) => {
//     try {
//       const response = await axiosInstance.get(`/provider/${id}/`, {
//         headers: getAuthHeaders(),
//       });

//       return response.data;
//     } catch (error) {
//       if (error.response) {
//         if (error.response.status === 401) {
//           console.error("Unauthorized! Token may be invalid or expired.");
//           toast.error("Session expired. Please log in again.");

//           // Token delete kar ke user ko login page pe bhejna
//           localStorage.removeItem("access_token");
//           window.location.href = "/"; // Redirect to login
//         }
//         return rejectWithValue(error.response.data);
//       }
//       return rejectWithValue("An error occurred");
//     }
//   }
// );


export const createNewCommunity = createAsyncThunk(
  "community/createNewCommunityapi",
  async (formData, { rejectWithValue }) => {
    try {
      // Add the static user_type field to the formData object
      const formDataWithUserType = { ...formData, user_type: "Provider" };

      const response = await axiosInstance.post(
        "/auth/provider/",
        formDataWithUserType,
        // { headers: getAuthHeaders() }
      );
      
      

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

//for delete a provider 
export const deleteCommunityData = createAsyncThunk(
  "community/deleteCommunityData",
  async (communityId, { rejectWithValue }) => {
    try {
     
      const response = await axiosInstance.put(
        `/auth/provider/delete/${communityId}`, // Endpoint
        {}, // Data payload (empty in this case for a PUT request)
        // { headers: getAuthHeaders() } 
        // Correct placement of headers
      );

    
    
      return response.data;
      
      
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


export const createNewCommunityGpt = createAsyncThunk(
  "community/createNewCommunityGpt",
  async (communityData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/community/community_check_or_create/",
        communityData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);




export const getAuthHeaders = () => {
  const token = localStorage.getItem('accessToken');
 
  if (!token) {
    throw new Error("Access token is missing. Please log in again.");
  }
  return {
    Authorization: `Bearer ${token}`,
  };
};


export const updateCommunityApi = createAsyncThunk(
  "community/UpdateCommunityApi",
  async ({ formData, id ,token_used}, { rejectWithValue }) => {
  
    const token = localStorage.getItem('accessToken');

    // Check if token exists
    if (!token) {
      console.error("No token found in localStorage");
      return rejectWithValue("Token missing");
    }

    try {
      const response = await axiosInstance.patch(
        `/auth/provider/${id}`,
        formData,
        token_used,
        { headers: getAuthHeaders() } // Ensure getAuthHeaders() includes the correct token
      );
     
      return response.data;
    } catch (error) {
      // Improved error handling
      console.error("Error occurred", error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);



export const createNewCommunitydd = createAsyncThunk(
  "community/createNewCommunityapi",
  async (formData, { rejectWithValue }) => {
    try {
      // Add the static user_type field to the formData object
      const formDataWithUserType = { ...formData, user_type: "Provider" };

      const response = await axiosInstance.post(
        "/auth/provider/",
        formDataWithUserType,
        // { headers: getAuthHeaders() }
      );
      
      

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


export const vendorCheckOrCreate = createAsyncThunk(
  "community/vendorCheckOrCreate",
  async (communityCity, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/community/vendor_check_or_create/",
        communityCity
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const healthVendorCheckOrCreate = createAsyncThunk(
  "community/healthVendorCheckOrCreate",
  async (communityCity, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/community/health_vendor_check_or_create/",
        communityCity
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const educationVendorCheckOrCreate = createAsyncThunk(
  "community/educationVendorCheckOrCreate",
  async (communityCity, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/community/education_vendor/",
        communityCity
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
